import * as actionTypes from '../actions/actionTypes'
import {updateObject} from "../../utility";

const initialState = {
    error: null,
    cpError: null,
    loading: false,
    fromPost: false,
    token: null,
    settings: {accounts: [], orgs: [], users: [], address: {}, userSessions: [], apiKey: null, scopings: [], ssoConfig: {}, spMetadata: {}}
};

const fetchAccountSettingsStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchAccountSettingsSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, settings: action.settings})
};

const fetchAccountSettingFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const saveCompanyInfoStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const saveCompanyInfoSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {...action.companyInfo});
    return updateObject(state, {loading: false, error: null, settings: newSettings})
};

const saveCompanyInfoFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const cancelCompanyInfo = (state, action) => {
    return state;
};

const addCloudAccountStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const addCloudAccountSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {accounts: action.accounts, orgs: action.orgs, gcpProjects: action.gcpProjects});
    return updateObject(state, {loading: false, error: null, settings: newSettings})
};

const addCloudAccountFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const editCloudAccountStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const editCloudAccountSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {accounts: action.accounts, orgs: action.orgs, gcpProjects: action.gcpProjects});
    return updateObject(state, {loading: false, error: null, settings: newSettings})
};

const editCloudAccountFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const deleteCloudAccountStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const deleteCloudAccountSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {accounts: action.accounts, orgs: action.orgs, gcpProjects: action.gcpProjects});
    return updateObject(state, {loading: false, error: null, settings: newSettings})
};

const deleteCloudAccountFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const addUserStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const addUserSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {users: action.users});
    return updateObject(state, {loading: false, error: null, settings: newSettings})
};

const addUserFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const editUserStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const editUserSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {users: action.users});
    return updateObject(state, {loading: false, error: null, settings: newSettings})
};

const editUserFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};


const deleteUserStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const deleteUserSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {users: action.users});
    return updateObject(state, {loading: false, error: null, settings: newSettings})
};

const deleteUserFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const deleteSessionStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const deleteSessionSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {userSessions: action.userSessions});
    return updateObject(state, {loading: false, error: null, settings: newSettings});
};

const deleteSessionFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error});
};

const editScopingStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const editScopingSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {scopings: action.scopings})
    return updateObject(state, {loading: false, error: null, settings: newSettings})
};

const editScopingFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const saveSsoConfigStart = (state, action) => {
    return updateObject(state, {loading: true});
}

const saveSsoConfigSuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {ssoConfig: action.ssoConfig, spMetadata: action.spMetadata});
    return updateObject(state, {loading: false, error: null, settings: newSettings});
}

const saveSsoConfigFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error});
}

const generateApiKeyStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const generateApiKeySuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {apiKey: action.apiKey});
    return updateObject(state, {loading: false, error: null, settings: newSettings});
};

const generateApiKeyFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error});
};

const deleteApiKeyStart = (state, action) => {
    return updateObject(state, {loading: true});
};

const deleteApiKeySuccess = (state, action) => {
    const newSettings = updateObject(state.settings, {apiKey: null});
    return updateObject(state, {loading: false, error: null, settings: newSettings});
};

const deleteApiKeyFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error});
};

const changePasswordStart = (state, action) => {
    return updateObject(state, {loading: true, fromPost: false})
};

const changePasswordSuccess = (state, action) => {
    return updateObject(state, {loading: false, cpError: null, fromPost: true, token: action.token})
};

const changePasswordFail = (state, action) => {
    return updateObject(state, {loading: false, cpError: action.error, fromPost: true})
};

// const toggleWeeklyEmailStart = (state, action) => {
//     return updateObject(state, {loading: true})
// };
//
// const toggleWeeklyEmailSuccess = (state, action) => {
//     const newSettings = updateObject(state.settings, {users: action.users});
//     return updateObject(state, {loading: false, error: null, settings: newSettings})
// };
//
// const toggleWeeklyEmailFail = (state, action) => {
//     return updateObject(state, {loading: false, error: action.error})
// };


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ACCOUNT_SETTINGS_FETCH_START:
            return fetchAccountSettingsStart(state, action);
        case actionTypes.ACCOUNT_SETTINGS_FETCH_SUCCESS:
            return fetchAccountSettingsSuccess(state, action);
        case actionTypes.ACCOUNT_SETTINGS_FETCH_FAIL:
            return fetchAccountSettingFail(state, action);
        case actionTypes.COMPANY_INFO_SAVE_START:
            return saveCompanyInfoStart(state, action);
        case actionTypes.COMPANY_INFO_SAVE_SUCCESS:
            return saveCompanyInfoSuccess(state, action);
        case actionTypes.COMPANY_INFO_SAVE_FAIL:
            return saveCompanyInfoFail(state, action);
        case actionTypes.COMPANY_INFO_SAVE_CANCEL:
            return cancelCompanyInfo(state, action);
        case actionTypes.ADD_CLOUD_ACCOUNT_START:
            return addCloudAccountStart(state, action);
        case actionTypes.ADD_CLOUD_ACCOUNT_SUCCESS:
            return addCloudAccountSuccess(state, action);
        case actionTypes.ADD_CLOUD_ACCOUNT_FAIL:
            return addCloudAccountFail(state, action);
        case actionTypes.EDIT_CLOUD_ACCOUNT_START:
            return editCloudAccountStart(state, action);
        case actionTypes.EDIT_CLOUD_ACCOUNT_SUCCESS:
            return editCloudAccountSuccess(state, action);
        case actionTypes.EDIT_CLOUD_ACCOUNT_FAIL:
            return editCloudAccountFail(state, action);
        case actionTypes.DELETE_CLOUD_ACCOUNT_START:
            return deleteCloudAccountStart(state, action);
        case actionTypes.DELETE_CLOUD_ACCOUNT_SUCCESS:
            return deleteCloudAccountSuccess(state, action);
        case actionTypes.DELETE_CLOUD_ACCOUNT_FAIL:
            return deleteCloudAccountFail(state, action);
        case actionTypes.ADD_USER_START:
            return addUserStart(state, action);
        case actionTypes.ADD_USER_SUCCESS:
            return addUserSuccess(state, action);
        case actionTypes.ADD_USER_FAIL:
            return addUserFail(state, action);
        case actionTypes.EDIT_USER_START:
            return editUserStart(state, action);
        case actionTypes.EDIT_USER_SUCCESS:
            return editUserSuccess(state, action);
        case actionTypes.EDIT_USER_FAIL:
            return editUserFail(state, action);
        case actionTypes.DELETE_USER_START:
            return deleteUserStart(state, action);
        case actionTypes.DELETE_USER_SUCCESS:
            return deleteUserSuccess(state, action);
        case actionTypes.DELETE_USER_FAIL:
            return deleteUserFail(state, action);
        case actionTypes.DELETE_APIKEY_START:
            return deleteApiKeyStart(state, action);
        case actionTypes.DELETE_APIKEY_SUCCESS:
            return deleteApiKeySuccess(state, action);
        case actionTypes.DELETE_APIKEY_FAIL:
            return deleteApiKeyFail(state, action);
        case actionTypes.GENERATE_APIKEY_START:
            return generateApiKeyStart(state, action);
        case actionTypes.GENERATE_APIKEY_SUCCESS:
            return generateApiKeySuccess(state, action);
        case actionTypes.GENERATE_APIKEY_FAIL:
            return generateApiKeyFail(state, action);
        case actionTypes.CHANGE_PASSWORD_START:
            return changePasswordStart(state, action);
        case actionTypes.CHANGE_PASSWORD_SUCCESS:
            return changePasswordSuccess(state, action);
        case actionTypes.CHANGE_PASSWORD_FAIL:
            return changePasswordFail(state, action);
        case actionTypes.DELETE_SESSION_START:
            return deleteSessionStart(state, action);
        case actionTypes.DELETE_SESSION_SUCCESS:
            return deleteSessionSuccess(state, action);
        case actionTypes.DELETE_SESSION_FAIL:
            return deleteSessionFail(state, action);
        case actionTypes.EDIT_SCOPING_START:
            return editScopingStart(state, action);
        case actionTypes.EDIT_SCOPING_SUCCESS:
            return editScopingSuccess(state, action);
        case actionTypes.EDIT_SCOPING_FAIL:
            return editScopingFail(state, action);
        case actionTypes.SSO_CONFIG_SAVE_START:
            return saveSsoConfigStart(state, action);
        case actionTypes.SSO_CONFIG_SAVE_SUCCESS:
            return saveSsoConfigSuccess(state, action);
        case actionTypes.SSO_CONFIG_SAVE_FAIL:
            return saveSsoConfigFail(state, action);

        // case actionTypes.TOGGLE_WEEKLY_EMAIL_START: return toggleWeeklyEmailStart(state, action);
        // case actionTypes.TOGGLE_WEEKLY_EMAIL_SUCCESS: return toggleWeeklyEmailSuccess(state, action);
        // case actionTypes.TOGGLE_WEEKLY_EMAIL_FAIL: return toggleWeeklyEmailFail(state, action);
        default:
            return state;
    }
};

export default reducer;
